import React from "react";
import Search from "@ciq/shared/components/search";
import {AddButton} from "@ciq/shared/components/buttons";

export default function SettingsSearch({buttonTitle, search, onSearch, onAdd, buttonDisabled = false}) {
  const hasButton = !!buttonTitle

  return (
    <div className="settings-search">
      <Search search={search} onSearch={onSearch}/>
      {hasButton && <AddButton disabled={buttonDisabled} onClick={onAdd}>{buttonTitle}</AddButton>}
    </div>
  )
}